import Nav from '@/components/Nav'
import Footer from '@/components/Footer'

function Privacy() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF7]">
      <Nav />
      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="font-mono text-xs uppercase tracking-widest text-[#0F766E] mb-4">
            Legal
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-medium leading-tight tracking-tight mb-10">
            Privacy<br />Policy
          </h1>

          <div className="prose prose-lg max-w-none space-y-8 text-[#0A0A0A]/80 leading-relaxed">
            <section>
              <h2 className="font-display text-2xl font-semibold mb-3 text-[#0A0A0A]">1. Information we collect</h2>
              <p>
                To provide the AI Readiness Assessment service, we collect information such as your name, email address, company, and role, with your consent.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-semibold mb-3 text-[#0A0A0A]">2. How we use information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To deliver your assessment results and related communications</li>
                <li>For service improvement through aggregated, non-identifying analytics</li>
                <li>To share related information within the scope of your consent</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-2xl font-semibold mb-3 text-[#0A0A0A]">3. Sharing with third parties</h2>
              <p>
                Except as required by law, we do not share your personal information with third parties without your consent.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-semibold mb-3 text-[#0A0A0A]">4. Security</h2>
              <p>
                We implement appropriate safeguards to prevent the leakage, loss, or damage of personal information.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-semibold mb-3 text-[#0A0A0A]">5. Contact</h2>
              <p>
                For requests to access, correct, or delete your personal information, please contact us at <a href="mailto:Triangleprojectconsultants@gmail.com" className="text-[#0F766E] underline">Triangleprojectconsultants@gmail.com</a> or call (919) 930-3059. Our office is located in Raleigh, NC.
              </p>
            </section>

            <p className="font-mono text-xs text-[#0A0A0A]/40 pt-8 border-t border-[#E5E5E5]">
              Last updated: 2025-01-16
            </p>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  )
}

export default Privacy
